<template>
  <div class="juke-box-modal__head relative py-8 px-6 bg-indigo-700 text-center">
    <mj-icon
      src="close"
      class="absolute right-0 mr-2 -mt-6 w-6 h-6 fill-current text-indigo-900 cursor-pointer"
      @click="onClose"
    />
    <slot />
  </div>
</template>

<script>
export default {
  methods: {
    onClose() {
      this.$modal.hide('root-modal');
    },
  },
};
</script>
